module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('admin-layout', [_c('div', {
    staticClass: "content",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v("Tags "), _c('button', {
    staticClass: "btn btn-custom",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleShowTagModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New")])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tagList), function(item) {
    return _c('tr', [_c('th', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.toggleShowTagModal(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      attrs: {
        "width": "120"
      }
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeTag(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v("Tag Rules "), _c('button', {
    staticClass: "btn btn-custom",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleShowTagRuleModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Rule")])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Definition")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tagRuleList), function(item) {
    return _c('tr', [_c('th', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.toggleShowTagRuleModal(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      attrs: {
        "width": "120"
      }
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeRule(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  }, [(_vm.showTagModal) ? _c('tag-modal', {
    attrs: {
      "tag": _vm.tag
    },
    on: {
      "close": _vm.closeTagModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTagRuleModal) ? _c('tag-rule-modal', {
    attrs: {
      "rule": _vm.rule,
      "tags": _vm.tagList
    },
    on: {
      "close": _vm.closeTagRuleModal
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f3def24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/TagsSettings.vue
// module id = 610
// module chunks = 0